import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line
import lazySizes from 'lazysizes';

export default class MarketingCard extends React.Component {
  render() {
    const { img, headline, paragraphs } = this.props;
    const imgPath =
      "https://res.cloudinary.com/localvore-today/image/upload/f_auto,w_400,c_fit/v1494892746/assets/marketing-card/";

    return (
      <div className="marketing-card mb-5">
        <div className="marketing-card-header mb-3">
          <img
            className="img-fluid lazyload"
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            data-src={imgPath + img}
            alt=""
            />
        </div>
        <p>{headline}</p>
        <hr className="w-25 orange" />
        <div className="marketing-card-body">
          {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    );
  }
}

MarketingCard.propTypes = {
  paragraphs: PropTypes.array.isRequired,
  img: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Card/MarketingCard.js